import * as Yup from "yup";

export const CommunityValueSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
});
